

import React from "react";

export default function Header() {
    const title = "MURSHIDABAD DISTRICT CENTRAL CO-OPERATIVE BANK LTD.";

    return (
        <header className="
            flex items-center justify-between
            px-3 py-3 
            bg-blue-300 border-b 
            flex-wrap xl:flex-nowrap gap-4
        ">
            {/* Left Box: Logo and Animated Text */}
            <div className="flex items-center gap-3 flex-wrap lg:flex-nowrap flex-1">
                {/* Logo */}
                <img
                    src="./images/logo_MD.webp"
                    alt="logo"
                    className="ml-2 w-[220px] lg:w-[320px] h-auto object-contain shrink-0"
                />

                {/* Static Bank Title */}
                <div
                    className="
                        font-sans tracking-tight font-bold text-blue-900

                        text-[1.1rem] 
                        max-[400px]:text-[0.95rem]
                        max-[330px]:text-[0.85rem]
                        lg:text-[2.2rem]
                        lg:mx-1

                        w-full lg:w-auto 
                        mt-2 lg:mt-0 

                        text-center lg:text-left
                        justify-center lg:justify-start
                    "
                >
                    {title}
                </div>
            </div>

            {/* Right Box: DICGC Logo */}
            <div className="hidden lg:flex w-full xl:w-auto justify-center xl:justify-end shrink-0">
                <img 
                    src="/images/dicgc_info_combined.webp" 
                    alt="DICGC Registration Info" 
                    className="h-14 lg:h-20 object-contain rounded-md shadow-sm border border-blue-200 bg-white p-1"
                />
            </div>
        </header>
    );
}
